'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ref;

/* injects from baggage-loader */

var firebase = require('firebase');

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyDyruKX8Qig8p2KIdcnN8MRMQKVvxJumhE',
  authDomain: 'meta-pro-naissur.firebaseapp.com',
  databaseURL: 'https://meta-pro-naissur.firebaseio.com',
  storageBucket: 'meta-pro-naissur.appspot.com',
  messagingSenderId: '723172402961'
};
firebase.initializeApp(config);

var rootRef = firebase.database().ref();

function ref(path, parentRef) {

  if (!path || path.length === 0) {
    return parentRef || rootRef;
  }

  if (parentRef) {
    var parentPath = parentRef.toString().replace(rootRef.toString(), '');
    return ref(parentPath + '/' + path);
  }

  return rootRef.child(path);
}

var auth = exports.auth = firebase.auth();


//////////////////
// WEBPACK FOOTER
// ./app/utils/firebase.js
// module id = 50
// module chunks = 1